import { FunctionComponent, useEffect, useState } from "react";
import { getActiveSite } from "../../selectors/sites.js";
import { injectScript } from "../../slices/loadStates.js";
import { useAppDispatch, useAppSelector } from "../../store/hooks.js";
import styles from "../../stylesheets/components/getavo-module.module.css";
import moduleBaseStyles from "../../stylesheets/components/module-base.module.css";
import { BaseModuleProps, GetavoModuleSettings } from "../../types/index.js";
import {
  getActiveColorScheme,
  getSupportedLanguage,
} from "../../utils/utils.js";
import LazyloadWrapper from "../LazyloadWrapper.js";
import ModuleHeadings from "../ModuleHeadings.js";
import ModuleWithHeadings from "../ModuleWithHeadings.js";

type Props = BaseModuleProps<GetavoModuleSettings>;

const GetavoModule: FunctionComponent<Props> = ({
  translatedModule: {
    id,
    settings: { textAlign, code },
    translation: {
      languageId,
      settings: { title, subtitle },
    },
  },
  translatedModule,
  isFirstOnPage,
  isPreview,
}) => {
  const dispatch = useAppDispatch();
  const scheme = useAppSelector((state) =>
    getActiveColorScheme(
      state.colorSchemes,
      getActiveSite(state.sites),
      translatedModule,
    ),
  );
  const [isLazyloaded, setIsLazyloaded] = useState(false);

  useEffect(() => {
    code &&
      isLazyloaded &&
      dispatch(injectScript("https://cdn.getavo.it/getavo.js"));
  }, [isLazyloaded, isPreview, code]);

  return (
    <ModuleWithHeadings
      title={title}
      subtitle={subtitle}
      id={id}
      className={styles.GetavoModule}
      colors={{ background: scheme.main.separator, color: scheme.main.text }}
    >
      <div className={moduleBaseStyles.Module__Wrapper}>
        <ModuleHeadings
          scheme={scheme}
          isFirstOnPage={isFirstOnPage}
          textAlign={textAlign}
          title={title}
          subtitle={subtitle}
        />
      </div>

      <LazyloadWrapper onLoad={setIsLazyloaded}>
        <div className={moduleBaseStyles.Module__Wrapper}>
          {!!code ? (
            <bn-getavo
              id="BN-getavo"
              class="BN-getavo"
              data-lang={getSupportedLanguage(languageId, ["de", "it", "en"])}
              data-code={code}
            />
          ) : (
            <div className={styles.GetavoModule__Empty}>Getavo</div>
          )}
        </div>
      </LazyloadWrapper>
    </ModuleWithHeadings>
  );
};

export default GetavoModule;
